import { Card } from '@etg/wings';
import { useMemo, useState } from 'react';
import { cx } from '@eti/styles';
import { useProductCardContext } from '../context/ProductCardContext';
import { BoundValues } from '../models/product';
import { cardWrapper, separator } from './styles';
import AvailabilityHeader from './AvailabilityHeader';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function filterAvailabilityList(list) {
  for (var _len = arguments.length, predicates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    predicates[_key - 1] = arguments[_key];
  }
  return list.filter(item => predicates.every(predicate => predicate(item)));
}
const isDeparting = availability => availability.boundIndex === BoundValues.Departing;
const isReturn = availability => availability.boundIndex === BoundValues.Returning;
const isAvailable = isCardSelected => availability => isCardSelected ? availability.available : true;
const AirportAvailability = _ref => {
  var _productData$extraPro;
  let {
    isSelected,
    className,
    testid,
    isMultiStop
  } = _ref;
  const [isOpen, setIsOpen] = useState(true);
  const productData = useProductCardContext();
  const {
    availabilityList,
    AirportListComponent
  } = productData.extraProps;
  const {
    departing,
    return: returnTitle
  } = (_productData$extraPro = productData.extraProps) === null || _productData$extraPro === void 0 || (_productData$extraPro = _productData$extraPro.availabilityTranslation) === null || _productData$extraPro === void 0 ? void 0 : _productData$extraPro.availabilityCard;
  const filteredList = useMemo(() => {
    if (isMultiStop) {
      return {
        departing: [],
        returning: [],
        multiStop: filterAvailabilityList(availabilityList, isAvailable(isSelected))
      };
    }
    return {
      departing: filterAvailabilityList(availabilityList, isDeparting, isAvailable(isSelected)),
      returning: filterAvailabilityList(availabilityList, isReturn, isAvailable(isSelected)),
      multiStop: []
    };
  }, [availabilityList, isSelected, isMultiStop]);
  const hideListTitle = filteredList.departing.length === 0 || filteredList.returning.length === 0 || Boolean(isMultiStop);
  const closeCard = (openStatus, cardSelected) => {
    if (cardSelected) {
      setIsOpen(!openStatus);
    }
  };
  return /*#__PURE__*/_jsxs(Card, {
    "aria-live": "polite",
    className: cx(cardWrapper, className),
    "data-testid": testid,
    children: [/*#__PURE__*/_jsx(AvailabilityHeader, {
      isOpen: isOpen,
      isSelected: isSelected,
      onClick: () => closeCard(isOpen, isSelected)
    }), isOpen && /*#__PURE__*/_jsxs(_Fragment, {
      children: [isSelected && /*#__PURE__*/_jsx("hr", {
        className: separator,
        "data-testid": "separator",
        role: "presentation"
      }), isMultiStop && /*#__PURE__*/_jsx(AirportListComponent, {
        availabilityList: filteredList.multiStop,
        hideTitle: hideListTitle,
        isSelected: isSelected,
        listTitle: departing,
        testId: "multi-stop-availability-list"
      }), !isMultiStop && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(AirportListComponent, {
          availabilityList: filteredList.departing,
          hideTitle: hideListTitle,
          isSelected: isSelected,
          listTitle: departing,
          testId: "depart-availability-list"
        }), /*#__PURE__*/_jsx(AirportListComponent, {
          availabilityList: filteredList.returning,
          hideTitle: hideListTitle,
          isSelected: isSelected,
          listTitle: returnTitle,
          testId: "return-availability-list"
        })]
      })]
    })]
  });
};
export default AirportAvailability;
//# sourceMappingURL=AirportAvailability.js.map